import { getSliders } from "../../../services/Api";
import { useEffect, useState } from "react";
import { getImageSliders } from "../../ultils";

const Slider = () => {
    const [sliders, setSliders] = useState([]);
	      useEffect(() => {
	        getSliders({
	          params: {
	            limit: 5,
	            sort: -1,
                // publish: true,//Back-end phải xử lý được true/false để ẩn hiện --> bổ sung code Back-end
	          },
	        })
	          .then(({ data }) => {
                // console.log(data.data.docs);
	            setSliders(data.data.docs);
	          })
	          .catch((error) => console.log(error));
	      }, []);

    return (
        <>
            {/*	Slider	*/}
            <div id="slide" className="carousel slide" data-ride="carousel">
                {/* Indicators */}
                <ul className="carousel-indicators">
	                    {
	                        sliders?.map((slider, index) => 
	                            slider.publish ? (
	                                <li key={index}
                                        data-target="#slide" 
	                                    data-slide-to={index} 
	                                    className={index===0?"active":""}
	                                     />
	                            ):null
	                        )
	                    }
                </ul>
                {/* The slideshow */}
                <div className="carousel-inner">
                {
	                            sliders?.map((slider, index) => 
	                                slider.publish ?
	                                (
	                                    <div className={index===0?"carousel-item active":"carousel-item"}>
	                                    <img
	                                        src={getImageSliders(slider.image)}
	                                        alt="Vietpro Academy"
	                                    />
	                                    </div>
	                                ):null
	                            )
                        }
                </div>
                {/* Left and right controls */}
                <a className="carousel-control-prev" href="#slide" data-slide="prev">
                    <span className="carousel-control-prev-icon" />
                </a>
                <a className="carousel-control-next" href="#slide" data-slide="next">
                    <span className="carousel-control-next-icon" />
                </a>
            </div>
            {/*	End Slider	*/}
        </>
    )
}
export default Slider;
